<template>
  <div class="main">
    <div class="title">捐献是否影响健康</div>

    <div class="content">
      <div class="sj">
       外周造血干细胞动员和采集过程是健康和安全的。首先，人体内的造血干细胞具有很强的再生能力。正常情况下，人体各种细胞每天都在不断新陈代谢，新生细胞不断地生成发育和成熟，替代衰老和死亡的细胞。失血和捐献造血干细胞后，可刺激骨髓加速干细胞再生和造血。在较短时间内，血液中的各种血细胞包括干细胞就可恢复到原来水平，至今没有因采集外周血造血干细胞影响捐献者造血过程的报道  。在采集完成后，一些轻微疼痛感和不适将会消失。其次，动员造血干细胞的粒系集落刺激因子是人体中的生理调节成分，没有毒性。据十多年的临床观察和国际、国内的报道，使用粒系集落刺激因子对人体健康没有副作用。最后，所用的器材都经严格消毒并一次性使用，不可能发生交叉感染。捐献者是清醒地接受采集，整个采集过程不需用麻醉或镇静药物，可以确保捐献者健康和安全。 </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>

<style lang="less" scoped>
.main {
  box-sizing: border-box;
  padding: 24px;
  width: 100vw;
  // height:630px;
  min-height: 100vh;
  font-size: 14px;

  background-image: url("../../assets/hscs/报名流程/bg.png");
  background-size: cover;

  .title {
    margin-top: 120px;
    font-size: 26px;
    font-weight: bold;
  }

  .content {
    margin-top: 16px;
    padding: 25px;
    // height: 450px;
    background-color: #fef2f4;
    border-radius: 10px;
  }
}
</style>